import InvestorRank from "../shared/holding/fundraising/AI-investors-ranking/InvestorRank.model";

export enum LpInterest {
  None = 0,
  Interested = 1,
  WouldLikeToLearnMore = 2,
  NotInterested = 3
}

// tslint:disable-next-line:no-namespace
export namespace LpInterest {
  export function toString(lpInterest: LpInterest): string {
    switch (lpInterest) {
      case LpInterest.Interested:
        return `Interested, let's proceed 🎉`;
      case LpInterest.WouldLikeToLearnMore:
        return 'Would like to learn more';
      case LpInterest.NotInterested:
        return 'Not interested';
      case LpInterest.None:
      default:
        return `Haven't replied yet`;
    }
}

  export function listAll() {
    return [LpInterest.Interested, LpInterest.WouldLikeToLearnMore, LpInterest.NotInterested];
  }
}
